import Crud from '../components/TransportationRequest/Crud'
import Add from '../components/TransportationRequest/Add'

import Approve from '../components/TransportationRequest/Approve'

let routes = {
    path: '/transportationRequest',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/transportationRequests',
            name: 'Solicitações de vale-transporte',
            component: Crud
        },
        {
            path: '/transportationRequest/:id?',
            name: 'Solicitação de vale-transporte',
            component: Add
        },
        {
            path: '/transportationRequests/approve',
            name: 'Aprovar solicitações de vale-transporte',
            component: Approve
        }
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/transportationRequest.js